module.exports = __webpack_public_path__ + "img/build_project.69c74e28.jpg";